export const FETCH_TOKEN_CONSUMPTION_REQUEST = (state, action) => {
  return {
    ...state,
    aiAgents: {
      ...state.aiAgents,
      usage: {
        ...state.aiAgents.usage,
        loading: true,
        error: null,
      }
    }
  };
};

export const FETCH_TOKEN_CONSUMPTION_SUCCESS = (state, action) => {
  return {
    ...state,
    aiAgents: {
      ...state.aiAgents,
      usage: {
        ...state.aiAgents.usage,
        loading: false,
        error: null,
        data: {
          byUser: action.payload.byUser || [],
          total: action.payload.total || { totalTokens: 0, transactionCount: 0 },
        },
        balance: action.payload.balance || {
          available: 0,
          credits: 0,
          monthly: 0,
          freeMonthly: 0,
          renewDate: null,
          usedThisMonth: 0,
        },
      }
    }
  };
};

export const FETCH_TOKEN_CONSUMPTION_ERROR = (state, action) => {
  return {
    ...state,
    aiAgents: {
      ...state.aiAgents,
      usage: {
        ...state.aiAgents.usage,
        loading: false,
        error: action.payload,
      }
    }
  };
};

export const SET_DATE_FILTER = (state, action) => {
  return {
    ...state,
    aiAgents: {
      ...state.aiAgents,
      usage: {
        ...state.aiAgents.usage,
        filters: {
          startDate: action.payload.startDate,
          endDate: action.payload.endDate,
        }
      }
    }
  };
};

